<template>
    <div>
        <!--d-none d-lg-block-->
        <v-data-table class="my-5 rounded bordered" v-model:expanded="tabel.laiendatud"
            :headers="tabel.paised" :items="elemendid" :items-per-page="tabel.lehePikkus" :loading="tabel.laeb"
            show-expand fixed-header single-expand item-key="id">
            <template v-slot:[`item.juhendajaAndmed`]="{ value }">
                <p v-for="(item, i) in value" :key="i"> {{ item }}</p>asdsd
            </template>
            <template #expanded-row="{ columns, item }">
                <tr>
                    <td :colspan="columns.length">
                        <AjakavaTabel :aluseId="aluseId" :broneeringuId="broneeringuId" :ajakavaId="ajakavaId"
                            :elemendid="(item.yktAjakavad as any)"></AjakavaTabel>
                    </td>
                </tr>
            </template>
            <template v-slot:bottom> </template>
        </v-data-table>
        <v-data-iterator class="d-lg-none d-none" :items="elemendid" item-value="id">
            <template v-slot:default="{ items }">
                <v-row>
                    <v-col class="w-100" cols="auto" v-for="item in items" :key="item.raw.id">
                        <v-card class="mx-auto">
                            <template v-slot:title>
                                ÜKT tööandja: {{ item.raw.yktTooandja }}
                            </template>
                            <template v-slot:prepend>
                                <v-btn v-if="broneeringuId && aluseId"
                                    @click="$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [aluseId.toString()] } });"
                                    icon="mdi-chevron-left"></v-btn>
                            </template>
                            <template v-slot:append>
                                <v-btn v-if="!broneeringuId && aluseId"
                                    @click="$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [aluseId.toString(), item.raw.id] } });"
                                    icon="mdi-chevron-right"></v-btn>
                            </template>
                            <v-expansion-panels>
                                <v-expansion-panel :title="item.raw.tookohaNimetus">
                                    <v-expansion-panel-text>
                                        <v-list :lines="false" density="compact">
                                            <v-list-item :title="item.raw.tegemiseKoht">
                                                <template v-slot:title="{ title }">
                                                    <b>ÜKT tegemise koht:</b> {{ title }}
                                                </template></v-list-item>
                                            <v-list-item :title="item.raw.juhendajaAndmed">
                                                <template v-slot:title="{ title }">
                                                    <div class="d-flex flex-row">
                                                        <v-sheet class="mr-2"><b>Juhendaja andmed:</b></v-sheet>
                                                        <v-sheet>
                                                            <p v-for="(andmed, i) in title" :key="i"> {{ andmed }}</p>
                                                        </v-sheet>
                                                    </div>
                                                </template></v-list-item>
                                        </v-list>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
        </v-data-iterator>
    </div>
</template>
<script lang="ts">
import { BroneeringListItem } from '@/models/UldkasulikToo';
import AjakavaTabel from './AjakavaTabel.vue';
import { PropType, defineComponent } from 'vue';
import mixin from '@/core/mixins';

export default defineComponent({
    name: 'BroneeringuTabel',
    components: { AjakavaTabel },
    mixins: [mixin],
    data() {
        return {
            tabel: {
                laiendatud: [] as Array<any>,
                paised: [
                    {
                        title: '',
                        key: 'data-table-expand',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        }
                    },
                    {
                        title: 'ÜKT tööandja',
                        sortable: false,
                        key: 'yktTooandja',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'Töökohanimetus',
                        sortable: false,
                        key: 'tookohaNimetus',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'ÜKT tegemise koht',
                        sortable: false,
                        key: 'tegemiseKoht',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                    {
                        title: 'Juhendaja andmed',
                        sortable: false,
                        key: 'juhendajaAndmed',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                ],
                laeb: false,
                lehePikkus: -1
            },
        }
    },
    props: {
        elemendid: Array as PropType<Array<BroneeringListItem>>,
        aluseId: Number as PropType<Number>,
        broneeringuId: Number as PropType<Number>,
        ajakavaId: Number as PropType<Number>,
        laiendatud: Array as PropType<Array<any>>,
    },
    watch: {
        broneeringuId: {
            handler: function () {
                this.uuendaLaiendatud();
            },
            deep: true
        },
    },
    mounted: function () {
        this.uuendaLaiendatud();
    },
    methods: {
        uuendaLaiendatud() {
            this.tabel.laiendatud = [];
            if (this.broneeringuId) this.tabel.laiendatud.push(this.broneeringuId);
        },
    }
});
</script>

<style scoped>
.bordered {
    border: 1px solid var(--varv-lisa-3);
}
</style>